import { render, staticRenderFns } from "./memberCardBuy.vue?vue&type=template&id=7d651c32&scoped=true&v-if=item.type%3D%3D%3D'TEXT'&"
import script from "./memberCardBuy.vue?vue&type=script&lang=js&"
export * from "./memberCardBuy.vue?vue&type=script&lang=js&"
import style0 from "./memberCardBuy.vue?vue&type=style&index=0&id=7d651c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d651c32",
  null
  
)

/* custom blocks */
import block0 from "./memberCardBuy.vue?vue&type=custom&index=0&blockType=div&v-if=data%20%26%26%20data.type.about&class=dataRect"
if (typeof block0 === 'function') block0(component)
import block1 from "./memberCardBuy.vue?vue&type=custom&index=1&blockType=div&v-if=data&class=dataRect"
if (typeof block1 === 'function') block1(component)
import block2 from "./memberCardBuy.vue?vue&type=custom&index=2&blockType=div&class=emptyRect"
if (typeof block2 === 'function') block2(component)
import block3 from "./memberCardBuy.vue?vue&type=custom&index=3&blockType=div&class=buttonRect"
if (typeof block3 === 'function') block3(component)

export default component.exports